(function () {
  'use strict';

  // tfc.Nav is defined in tfc-sso
  angular
      .module('tfc.retailer.StandardReports')
      .directive('topNav', topNav)
      .config(config);

  // @ngInject
  function config($stateProvider) {

    $stateProvider
        .state('storePage', {
          abstract : true,
          templateUrl : 'StandardReports/Nav/StorePage.tmpl.html',
          controller: 'StorePageCtrl as vm',
          url : '/standard-report?storeKey&startDate&endDate&country&continent&deviceType&' +
              'department&category&classification&detailLevel&addressable&uiLocale',
          params: {
            storeKey: {array: true},
            deviceType: {array: true},
            continent: {array: true},
            country: {array: true},
            uiLocale: {array: true},
            addressable: {type: 'bool'}
          },
          onEnter: function(LookAndFeel, LookAndFeelType, GaUtil) {
            if(!LookAndFeel.isAnalytics()) {
              GaUtil.setGaDimension('dimension2', LookAndFeelType.Analytics);
              LookAndFeel.setToAnalytics();
            }
          },
          resolve: {
            userStores: function (StandardReports) {
              return StandardReports.findUserStores();
            },
            storeKeys: function (StandardReports, userStores, $stateParams) {
              return StandardReports.defaultSelectedStores(userStores, $stateParams.storeKey);
            },
            filters: function (StandardReports, $stateParams, Filters, storeKeys) {
              return StandardReports.getConsumerFilters(storeKeys).then(function (filters) {
                var dimensions = filters.dimensions;
                Filters.createFilter(dimensions, $stateParams);
                return Filters.getFilterParams();
              });
            }
          }
        });
  }

  function topNav() {
    return {
      restrict: 'E',
      templateUrl : 'StandardReports/Nav/TopNav.tmpl.html',
      scope: true
    };
  }

})();
